import React, { useState, useEffect } from 'react';
import api from '../api/axios';

const Streaming = () => {
    const [streaming, setStreaming] = useState({ url: '', description: '' });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchStreaming = async () => {
            try {
                const response = await api.get('/streaming');
                setStreaming(response.data);
            } catch (error) {
                console.error("Error fetching", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchStreaming();
    }, []);

    const handleSave = async (e) => {
        e.preventDefault();
        setIsSaving(true);
        setMessage('');
        try {
            await api.put('/streaming', streaming);
            setMessage('Configuración de streaming guardada con éxito.');
            setTimeout(() => setMessage(''), 3000);
        } catch (error) {
            console.error("Error saving", error);
            setMessage('Error al guardar la configuración.');
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto animate-fadeIn">
            <header className="mb-10">
                <h1 className="text-4xl font-extrabold text-slate-900 tracking-tight">Configuración de Streaming</h1>
                <p className="text-slate-500 mt-2">Configura el reproductor en vivo para los asistentes.</p>
            </header>

            {isLoading ? (
                <div className="text-center py-20 text-slate-400">Cargando configuración...</div>
            ) : (
                <div className="bg-white rounded-[40px] shadow-sm border border-slate-100 overflow-hidden flex flex-col md:flex-row">
                    <div className="bg-slate-900 p-10 w-full md:w-1/2 flex flex-col justify-center items-center text-center">
                        <div className="w-20 h-20 bg-blue-600 rounded-full flex items-center justify-center text-3xl mb-6 shadow-xl shadow-blue-500/20">
                            📺
                        </div>
                        <h2 className="text-white text-2xl font-black mb-4 leading-tight">Previsualización del Reproductor</h2>
                        <p className="text-slate-400 text-sm mb-8 leading-relaxed">Así es como el reproductor se verá para el usuario final.</p>
                        
                        <div className="w-full aspect-video bg-slate-800 rounded-2xl overflow-hidden border border-white/5 shadow-2xl relative group">
                            {streaming.url ? (
                                <iframe 
                                    src={streaming.url} 
                                    className="w-full h-full" 
                                    frameBorder="0" 
                                    allow="autoplay; fullscreen" 
                                    allowFullScreen
                                    title="Streaming Preview"
                                ></iframe>
                            ) : (
                                <div className="flex flex-col items-center justify-center h-full text-slate-500 px-6">
                                    <span className="text-4xl mb-4 grayscale">🎬</span>
                                    <p className="text-xs font-bold uppercase tracking-widest leading-relaxed">Sin URL de Streaming Configurara</p>
                                </div>
                            )}
                        </div>
                    </div>

                    <form onSubmit={handleSave} className="p-10 w-full md:w-1/2 bg-white space-y-8">
                        <div>
                            <label className="block text-slate-400 text-[10px] font-black tracking-widest uppercase mb-3 pl-1">URL del Streaming (Iframe src)</label>
                            <input 
                                className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl focus:outline-none focus:ring-4 focus:ring-blue-100 transition-all font-mono text-sm shadow-inner"
                                placeholder="https://www.youtube.com/embed/..."
                                value={streaming.url}
                                onChange={e => setStreaming({...streaming, url: e.target.value})}
                                required
                            />
                            <p className="text-[10px] text-slate-400 mt-3 italic pl-1">Utiliza el enlace 'embed' de YouTube o Vimeo.</p>
                        </div>

                        <div>
                            <label className="block text-slate-400 text-[10px] font-black tracking-widest uppercase mb-3 pl-1">Descripción del Evento en Vivo</label>
                            <textarea 
                                className="w-full bg-slate-50 border border-slate-100 p-4 rounded-2xl h-40 focus:outline-none focus:ring-4 focus:ring-blue-100 transition-all shadow-inner leading-relaxed text-slate-700"
                                placeholder="Escribe una breve descripción del streaming..."
                                value={streaming.description}
                                onChange={e => setStreaming({...streaming, description: e.target.value})}
                            />
                        </div>

                        {message && (
                            <div className={`p-4 rounded-xl text-sm font-bold text-center ${message.includes('éxito') ? 'bg-emerald-50 text-emerald-600 border border-emerald-100' : 'bg-red-50 text-red-600 border border-red-100'}`}>
                                {message}
                            </div>
                        )}

                        <button 
                            type="submit" 
                            disabled={isSaving}
                            className="w-full bg-slate-900 text-white px-12 py-4 rounded-2xl font-black shadow-xl shadow-slate-900/10 hover:bg-slate-800 transition-all transform hover:scale-[1.02] active:scale-95 disabled:opacity-50"
                        >
                            {isSaving ? 'Guardando...' : 'Actualizar Configuración de Vivo'}
                        </button>
                    </form>
                </div>
            )}
        </div>
    );
};

export default Streaming;
